import { $$ } from '@suntex.core/text'
import { removePrefix } from '@suntex.core/text/transforms'
import {
  $GymMode,
  $JtfMode,
  $ModuleInfo,
  ArithmeticOperation,
  GymMode,
  JtfMode,
  ModuleInfo
} from '@suntex.fim/enums'

export function arithmeticOperationsAddSub(): ArithmeticOperation[] {
  return [ArithmeticOperation.Addition, ArithmeticOperation.Subtraction]
}

export function arithmeticOperationsMulDiv(): ArithmeticOperation[] {
  return [ArithmeticOperation.Multiplication, ArithmeticOperation.Division]
}

export function justTheFactsModuleId(
  jtfMode: JtfMode,
  arithmeticOperation: ArithmeticOperation
): ModuleInfo {
  //map the mode and op to a module by choosing the base module for the mode and offset by the op

  switch (jtfMode) {
    case JtfMode.WholeNumbers:
      return $ModuleInfo.from(ModuleInfo.jtf_100_add - 1 + arithmeticOperation)
    case JtfMode.Integers:
      return $ModuleInfo.from(
        ModuleInfo.jtf_100_int_add - 1 + arithmeticOperation
      )
    case JtfMode.Decimals:
      return $ModuleInfo.from(
        ModuleInfo.jtf_100_dec_add - 1 + arithmeticOperation
      )
    case JtfMode.Fractions:
      return $ModuleInfo.from(
        ModuleInfo.jtf_100_frc_add - 1 + arithmeticOperation
      )
    default:
      return $JtfMode.throwInvalid(jtfMode)
  }
}

export function gymsModuleId(
  gymMode: GymMode,
  arithmeticOperation: ArithmeticOperation
): ModuleInfo {
  //map the mode and op to a module by choosing the base module for the mode and offset by the op
  switch (gymMode) {
    case GymMode.WholeNumbers:
      return $ModuleInfo.from(ModuleInfo.gym_num_add - 1 + arithmeticOperation)
    case GymMode.Fractions:
      return $ModuleInfo.from(ModuleInfo.gym_frc_add - 1 + arithmeticOperation)
    case GymMode.Decimals:
      return $ModuleInfo.from(ModuleInfo.gym_dec_add - 1 + arithmeticOperation)
    case GymMode.Integers:
      return $ModuleInfo.from(ModuleInfo.gym_int_add - 1 + arithmeticOperation)
    case GymMode.K2:
      return $ModuleInfo.from(ModuleInfo.gym_k2_add - 1 + arithmeticOperation)
    default:
      return $GymMode.throwInvalid(gymMode)
  }
}

export function skillSetModuleId(skillSet: number, game: number): ModuleInfo {
  // eslint-disable-next-line no-magic-numbers
  return $ModuleInfo.from(3 * (skillSet - 1) + game)
}

function isLocalhost(url: string = '') {
  if (url === '') url = window.location.href

  return url.includes('localhost')
}

function isDev(url: string = '') {
  if (url === '') url = window.location.href

  return url.includes('dev')
}

//function isUat(url: string = "")
//{
//    if (url.isBlank())
//        url = window.location.href;

//    return url.includes("uat")
//}

export function fimCdnAnimateUrl(src: string): string {
  src = $$(src, removePrefix('/'))

  //if running on localhost
  if (isLocalhost()) {
    //use the reference as is, to the local file, but in the special cdn mock folder
    return '/cdn/content/animate/' + src
  }
  //running on the server
  else {
    const hostType = isDev() ? 'dev' : 'live'

    //return the cdn qualified url for the current host type
    return `https://cdn.firstinmath.com/content/animate/${hostType}/${src}`
  }
}
